import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { SupplyDropRequirementsModalComponent } from '@features/supply-drop/supply-drop-requirements-modal/supply-drop-requirements-modal.component';

export function provideSupplyDropModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'SupplyDropRequirementsModal', component: SupplyDropRequirementsModalComponent }, multi: true },
  ];
}
